import { LANGUAGES, useI18n } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, CaretDown, Check } from "@phosphor-icons/react";

export default function LanguageSelector({ compact = false }) {
  const { lang, setLang, t } = useI18n();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-selector-trigger"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-xs text-slate-300 border border-white/10 hover:border-white/25 hover:bg-white/[0.03] transition-all"
          aria-label={t("lang.select")}
        >
          <Globe weight="bold" className="h-3.5 w-3.5" />
          <span className="font-medium">
            {compact ? current.code.toUpperCase() : current.name}
          </span>
          <CaretDown weight="bold" className="h-3 w-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        data-testid="lang-selector-menu"
        className="min-w-[180px] bg-slate-950/95 border-white/10 text-white backdrop-blur-xl"
      >
        {LANGUAGES.map((l) => {
          const active = l.code === lang;
          return (
            <DropdownMenuItem
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onSelect={() => setLang(l.code)}
              className={`flex items-center justify-between gap-3 cursor-pointer ${
                active ? "text-white bg-white/[0.05]" : "text-slate-300"
              } focus:bg-white/[0.08]`}
            >
              <span className="flex items-center gap-2">
                <span className="text-base leading-none">{l.flag}</span>
                <span className="text-sm">{l.name}</span>
              </span>
              {active && <Check weight="bold" className="h-4 w-4 text-pink-400" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
